module.exports = __webpack_public_path__ + "img/icon-close.af81e679.svg";